import tokens from '@hrmydeck/design-tokens/tokens.json';

export type ModuleKey = keyof typeof tokens.modules;

export const modules = tokens.modules;

export const sectionTitle = 'text-sm font-medium text-foreground';

export function moduleTile(key: ModuleKey) {
  const m = modules[key];
  return `flex h-10 w-10 items-center justify-center rounded-xl border ${m.border} ${m.bg} ${m.icon}`;
}
